/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FabMessageService} from '@fabric/components/message';
import {
  ColDef,
  GridApi,
  GridReadyEvent,
  SizeColumnsToContentStrategy,
  SizeColumnsToFitGridStrategy,
  SizeColumnsToFitProvidedWidthStrategy
} from 'ag-grid-community';
import {AutocompleteFilterComponent} from '../../../filters/autocomplete-filter/autocomplete-filter.component';

@Component({
    selector: 'app-table-display-pop-up',
    templateUrl: './table-display-pop-up.component.html',
    styleUrl: './table-display-pop-up.component.scss',
    standalone: false
})
export class TableDisplayPopUpComponent {
  gridApi: GridApi;

  title: string;
  displayedColumns: string[] = []
  tableData: Map<string, any>;
  tabKeys: string[] = [];
  displayedData: any[] = [];
  scenarios: any[] = [];
  colDef: ColDef[] = [];

  pageSize: number;

  autoSizeStrategy:
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy = {
    type: "fitCellContents",
  };

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: any,
              public dialogRef: MatDialogRef<TableDisplayPopUpComponent>,
              public snackBar: FabMessageService) {
    if (data) {
      if (!data.title) {
        this.dialogRef.close();
      }
      this.title = data.title;
      this.tableData = data.tableData
      this.displayedColumns = data.displayedColumns;
      for (const key of this.tableData.keys()) {
        this.tabKeys.push(key);
      }

      this.displayedData = this.tableData.get(this.tabKeys[0]);
    }
  }

  /**
   * Gets the grid API and data when the grid is ready
   * @param params the parameters generated by the grid event
   */
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.colDef = this.generateColDef(this.displayedColumns);
  }

  generateColDef(columns: string[]): any[] {
    const colDefs: ColDef[] = [];
    for (const column of columns) {
      colDefs.push({
        field: column,
        headerName: column,
        filter: AutocompleteFilterComponent,
        lockVisible: true,
      });
    }
    return colDefs;
  }

  /**
   * Event handler for tab change
   * @param event the event object with the tab data
   */
  onTabChangeEvent(event: any) {
    this.displayedData = this.tableData.get(event.tab.textLabel);
  }

}
